module.exports = __webpack_public_path__ + "img/10026.15535b36.png";